import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { modalState } from '@/state/modal.state';
import { useSetAtom } from 'jotai';

export const useAccountSwitchNotificationFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setModal = useSetAtom(modalState);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const accountSwitched = searchParams.get('accountSwitched');
    if (accountSwitched === 'true' && !hasShown) {
      const accountName = searchParams.get('accountName') || '';
      const previousAccountName = searchParams.get('previousAccountName') || '';
      const entityType = searchParams.get('entityType') || '';

      if (accountName && previousAccountName && entityType) {
        setModal({
          state: 'accountSwitchNotification',
          accountName,
          previousAccountName,
          entityType,
        });

        // Remove the params after showing the modal
        searchParams.delete('accountSwitched');
        searchParams.delete('accountName');
        searchParams.delete('previousAccountName');
        searchParams.delete('entityType');
        setSearchParams(searchParams, { replace: true });

        setHasShown(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);
};
